import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSearchParams } from "react-router-dom";
import PublicPageLayout from "../PublicPageLayout";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
const RegistrationExistsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    let embeddedParam = searchParams.get("embedded");
    let isEmbedded = false;
    if (embeddedParam != null) {
        if ("0" !== embeddedParam && "FALSE" !== embeddedParam?.toUpperCase()) {
            isEmbedded = true;
        }
    }
    if (isEmbedded) {
        return (_jsxs("div", { children: [_jsx("h2", { children: "Account Already Exists" }), _jsx("h4", { children: "We have found an existing account with similar details.  Use the contact menu option above to contact us and we will upgrade or change your account details." })] }));
    }
    return (_jsxs(PublicPageLayout, { heading: "Account Already Exists", footer: _jsxs("a", { href: "#/login", children: [_jsx(QuestionCircleOutlined, {}), " Log in?"] }), children: [_jsx("p", { children: "We have found an existing account with similar details.  Use the button below to contact us and we will upgrade or change your account details." }), _jsx(Button, { type: "primary", href: 'https://www.subtrux.com/contact/', children: "Contact us!" })] }));
};
export default RegistrationExistsPage;
